import type { DemoScript } from "../types.js";

/**
 * Onboarding theme step: a STATIC 7-day calendar filled with example tasks —
 * no runner choreography (steps is empty), just the real calendar rendering a
 * believable week. Its purpose is the host's live `setTheme` forwarding: pick
 * a preset in onboarding and the whole preview re-colors instantly. Topics
 * carry the theme's entity palette, so blocks show several palette colors per
 * preset; a couple of flagged tasks show the priority accents too. Days view
 * (anchored on today) so all seven columns are always on-grid.
 */
export const themePreview: DemoScript = {
  id: "theme-preview",
  titleKey: "demos.title.themePreview",
  view: { kind: "days", count: 7 },
  stage: { width: 1100, height: 620 },
  topics: [
    { ref: "work", nameKey: "demos.topic.work", icon: "💼" },
    { ref: "family", nameKey: "demos.topic.family", icon: "👪" },
    { ref: "health", nameKey: "demos.topic.health", icon: "🏃" },
    { ref: "home", nameKey: "demos.topic.home", icon: "🏡" },
  ],
  fixture: [
    { ref: "standup", titleKey: "demos.fx.standup", dayOffset: 0, hour: 9, durationMin: 30, isEvent: true, topicRef: "work" },
    { ref: "report", titleKey: "demos.fx.writeReport", dayOffset: 0, hour: 14, durationMin: 90, priority: "high", topicRef: "work" },
    { ref: "gym", titleKey: "demos.fx.gym", dayOffset: 0, hour: 18, durationMin: 60, isEvent: true, topicRef: "health" },
    { ref: "design", titleKey: "demos.fx.designReview", dayOffset: 1, hour: 11, durationMin: 60, isEvent: true, topicRef: "work" },
    { ref: "lunch", titleKey: "demos.fx.lunch", dayOffset: 1, hour: 12, minute: 30, durationMin: 45, isEvent: true, topicRef: "family" },
    { ref: "errands", titleKey: "demos.fx.errands", dayOffset: 2, hour: 10, durationMin: 60, topicRef: "home" },
    { ref: "slides", titleKey: "demos.fx.prepSlides", dayOffset: 2, hour: 15, durationMin: 90, topicRef: "work" },
    { ref: "quarterly", titleKey: "demos.fx.quarterlyReport", dayOffset: 3, hour: 9, minute: 30, durationMin: 120, isEvent: true, topicRef: "work" },
    { ref: "hotel", titleKey: "demos.fx.bookHotel", dayOffset: 3, hour: 16, durationMin: 45, topicRef: "family" },
    { ref: "trip", titleKey: "demos.fx.planTrip", dayOffset: 4, hour: 10, durationMin: 120, isEvent: true, topicRef: "family" },
    { ref: "taxes", titleKey: "demos.fx.taxes", dayOffset: 4, hour: 14, durationMin: 60, priority: "medium", topicRef: "home" },
    { ref: "paint", titleKey: "demos.fx.paint", dayOffset: 5, hour: 11, durationMin: 60, topicRef: "home" },
    { ref: "dinner", titleKey: "demos.fx.dinner", dayOffset: 5, hour: 18, minute: 30, durationMin: 120, isEvent: true, topicRef: "family" },
    { ref: "hike", titleKey: "demos.fx.hike", dayOffset: 6, hour: 10, durationMin: 150, isEvent: true, topicRef: "health" },
    { ref: "renovation", titleKey: "demos.fx.renovation", dayOffset: 6, hour: 15, durationMin: 90, topicRef: "home" },
  ],
  steps: [],
};
